import React, { useContext } from 'react'
import { QuizQuestionContext, SCREEN_QUIZ_QUESTION } from '../contextAPI'
import { QuizQuestionBase } from '../QuizQuestion'

export const PinterestAvailabilityPage: React.FC = () => {
  const { setQuizScreen } = useContext(QuizQuestionContext)
  setQuizScreen(SCREEN_QUIZ_QUESTION.PINTEREST_AVAILABILITY)
  return <QuizQuestionBase hardScreen={SCREEN_QUIZ_QUESTION.PINTEREST_AVAILABILITY} />
}
